import type { DeliveryTaskFilters } from "@/infrastructure/repositories/delivery-tasks.supabase.repository";

export const deliveryTasksKeys = {
  all: ["delivery-tasks"] as const,
  list: (filters: DeliveryTaskFilters = {}) => [...deliveryTasksKeys.all, "list", filters] as const,
};
